import { useOutletContext } from "react-router-dom";

const INDIA = "india";

type TResidencyOutletContext = {
  settings?: { audioDataResidency?: string };
  company?: { audioDataResidency?: string };
};

// Mirrors the backend's resolveAudioDataResidency (strictest wins): an assistant resolves to
// India when India is set on the assistant, its workspace, or the company. Workspace settings
// and company come from Home's outlet context — settings are fetched for the active workspace,
// which is the workspace every assistant page is loaded from.
//
// Inert in Catalyst today: audioDataResidency does not exist anywhere in this repo (no UI, no
// company/workspace field, no backend setting), so assistantResidency/settings/company will
// never carry it and this always resolves to false. Degrades to false rather than throwing when
// the field is simply absent from the object (optional chaining below), not just when it's
// explicitly set to something other than "india".
export function useIsIndiaResidency(assistantResidency?: string): boolean {
  const { settings, company } =
    useOutletContext<TResidencyOutletContext>() ?? {};

  return (
    assistantResidency === INDIA ||
    settings?.audioDataResidency === INDIA ||
    company?.audioDataResidency === INDIA
  );
}
